import {down, up} from 'styled-breakpoints';
import styled from 'styled-components';

export const MobileWrapper = styled.div`
  display: none;
  ${down('md')} {
    display: block;
  }
`;

export const DesktopWrapper = styled.div`
  display: none;
  ${up('md')} {
    display: block;
  }
`;
